<template>
  <!-- v-if='dictCode' -->
  <a-card size='small' style='margin-bottom: 16px'>
    <a-space :size='12'>
      <label>公式更新元素选项：</label>
      <a-tag v-for='item in dictItemList' :key="item.value">{{item.text}}</a-tag>
    </a-space>
  </a-card>
</template>

<script>
export default {
  name: 'DictItemTexts',
  props: ['dictItemList'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>
